import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'
import { IPostInstallment } from '../models/models'

export class AddInstallemntsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/addInstallment',
      requesterInfo,
    })
  }

  public async addInstallemnts(request: IPostInstallment[]): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
